<template>
  <div>
    <div class="white black--text">
<!--      <div class="subheading font-weight-thin">Search Contact</div>-->
      <v-col
          class="d-flex"
          cols="12"
          sm="12"
      >
        <v-select
            :items="methodsOnlyList"
            label="Select payment method"
            dense
            outlined
            v-model="selectedMethodsName"
        ></v-select>
      </v-col>
    </div>
  </div>
</template>
<script>
import {collection, getDocs} from "firebase/firestore";

export default {
  data () {
    return {
      searchUser: '',
      clientUser: false,
      sortedContacts: [],
      newUserDialog: false,
      phoneNumber: '+1',
      email: '',
      paymentMethodsList: undefined,
      methodsOnlyList: undefined,
      selectedPhoneNumber: '',
      selectedMethodsName: ''
    }
  },
  created () {
    let db = this.$store.state.db
    let uid = this.user.uid
    let paymentsRef = getDocs(collection(db, 'users', uid+ '/paymentMethods'))
    return paymentsRef
        .then (methods => {
          let methodsList = []
          let methodNamesOnly = []
          methods.forEach (method => {
          if(method.data().enabled) {
            methodsList.push(method.data())
            methodNamesOnly.push(method.data().paymentMethod)
          }
          })
          this.paymentMethodsList = methodsList
          this.methodsOnlyList = methodNamesOnly
        })
  },
  watch: {
    selectedMethodsName (value) {
      if (value !== '') {
        this.loadPaymentMethod(value)
      }
    }
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    filteredList () {
      if(this.sortedContacts.length !== 0) {
        return this.sortedContacts.filter((user) => {
          return user.name.toLowerCase().match(this.searchUser.toLowerCase())
        })
      } else return []
    },
    loading () {
      return this.$store.getters.loading
    },
    user () {
      return this.$store.getters.user
    }
  },
  methods: {
    loadPaymentMethod (methodName) {
      let obj = this.paymentMethodsList.find(method => {
        return method.paymentMethod === methodName
      })
      this.$emit('paymentMethodPicked', obj)
    }
  }
}
</script>
